import { Badge, Box, HStack, Tag, Text, VStack } from "@chakra-ui/react";
import { components } from "../../../shared/schema/schema";
import { title } from "./servicePlanWeek.utils";

type CoServicePlanImportViolation = components["schemas"]["CoServicePlanImportViolation"];

/**
 * The verifier's findings, written the same way wherever a week's are read.
 *
 * A file of its own rather than an export from the drawer, for the same reason
 * `servicePlanWeek.utils` is one: the drawer opens the editor, the editor opens the
 * confirm dialog, and the dialog shows these — importing them back out of the drawer
 * would be a cycle.
 *
 * Severity is not drawn here. Every caller already groups by it and heads each group
 * with what it means — "Blocking findings" against "Warnings" — so colouring the
 * badge would state the same fact a second time, and would state it in the one place
 * that cannot also say what follows from it.
 */
export default function ServicePlanViolationList(props: {
  violations: CoServicePlanImportViolation[];
}) {
  return (
    <VStack align="stretch" spacing={2}>
      {props.violations.map((violation, i) => (
        <Box key={i} borderWidth="1px" p={3} rounded="md">
          <HStack spacing={2} wrap="wrap">
            <Badge colorScheme="purple">{violation.code}</Badge>
            {violation.dayOfWeek !== null && <Tag size="sm">{title(violation.dayOfWeek)}</Tag>}
            {violation.dutyCode !== null && <Tag size="sm">Duty {violation.dutyCode}</Tag>}
            {violation.caregiverId !== null && (
              <Tag size="sm">Caregiver #{violation.caregiverId}</Tag>
            )}
          </HStack>
          <Text fontSize="sm" mt={2}>
            {violation.message}
          </Text>
        </Box>
      ))}
    </VStack>
  );
}
